import Button from "components/Button";
import React from "react";
import classes from "./BookingWidgetBarDefault.module.css";
import { useBottomBarSize } from "../../../../hooks/useBottomBarSize";
import Typography from "components/Typography";
import classnames from "classnames";
import { formatNumber } from "utils/convertCents";

export const BookingWidgetBarDefault = (props) => {
  const {
    minimumDuration,
    setShowCalendar,
    dailyRateInitial,
    newPrice,
    price_per_night,
    nights,
    old_price,
    setShowPriceTable,
    priceTableLoading
  } = props;

  const barRef = useBottomBarSize();

  return (
    <div className={`${classes.BookingWidgetBarDefault}`} ref={barRef}>
      <div className={`${classes.bookingWidgetBarDefaultLeftColumn}`}>
        {!priceTableLoading ? (
          <div className={`${classes.bookingWidgetBarDefaultPriceContainer}`}>
            <div className={classes.priceNewPriceContainer} onClick={() => setShowPriceTable(true)}>
              <Typography
                variant="subtitle"
                size="m"
                className={classnames('underline', classes.priceNewPrice)}
              >
                ${formatNumber(newPrice)} total
              </Typography>
            </div>
            <div>
              <Typography
                variant="body"
                size="s"
                className={classes.priceNights}
              >
                for {nights}-night min stay
              </Typography>
            </div>
            <div>
              <Typography
                variant="caption"
                className={classes.pricePerNights}
              >
                ${formatNumber(price_per_night)} nightly rate
              </Typography>
            </div>
          </div>
        ) : null}
      </div>

      <div className={`${classes.bookingWidgetBarDefaultRightColumn}`}>
        <div className={`${classes.bookingWidgetBarDefaultButtonContainer}`}>
          <Button
            onClick={() => {
              setShowCalendar(true);
            }}
            className={`${classes.bookingWidgetBarDefaultButton}`}
            label="Check availability"
          />
        </div>
      </div>
    </div>
  );
};
